module.exports = __webpack_public_path__ + "img/movieTheater-2.f114e44d.jpg";